module.exports = __webpack_public_path__ + "img/thumbnail-cat-black.4c37e58c.jpg";